/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { UpdateZoneValue, UpdateZoneRule } from 'solis/claude/action';
import useColonyContext from 'solis/claude/action/context/colony';

import ColonyCard from 'solis/claude/card/colony';
import SectorCard from 'solis/claude/card/colony.sector';
import ZoneCard from 'solis/claude/card/colony.zone';


export default () =>
{
  const context = useColonyContext();

  const { colony, zone, account } = context;

  return (
    <Flex direction = 'column' gap = '4' p = '4'>

      <ColonyCard colony = {colony} account = {account} />

      {zone !== null && <SectorCard sector = {zone.getSector()} />}
      {zone !== null && <ZoneCard zone = {zone} />}

      <UpdateZoneValue context = {context} />
      <UpdateZoneRule context = {context} />

    </Flex>
  );
};
